export const CLOUDY_TIMEOUT_MS = 15000

export const CLOUDY_TIMEOUT_MESSAGE = "Request timed out. Please try again."

/**
 * One abortable request scope. It aborts after `timeoutMs`, or when disposed
 * (the effect that started the request was cleaned up). It remembers which of
 * the two happened, so callers can show an error for a timeout but stay silent
 * for a cancellation.
 */
export const createRequestScope = (timeoutMs: number) => {
  const controller = new AbortController()
  let timedOut = false
  const timer = setTimeout(() => {
    timedOut = true
    controller.abort()
  }, timeoutMs)

  return {
    signal: controller.signal,
    /** Stops the timer once the request has settled, so it can no longer abort anything. */
    settle: () => clearTimeout(timer),
    /** Cancels an in-flight request (effect cleanup). */
    dispose: () => {
      clearTimeout(timer)
      controller.abort()
    },
    /** The message to show for an error the request threw, or undefined when it was only cancelled. */
    errorMessage: (e: unknown): string | undefined => {
      if (timedOut) return CLOUDY_TIMEOUT_MESSAGE
      if (controller.signal.aborted) return undefined
      return e instanceof Error ? e.message : String(e)
    },
  }
}
